var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 32,
    cy: 48,
    rx: 16,
    ry: 10,
    fill: "#4B164C"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 22,
    cy: 38,
    rx: 6,
    ry: 6,
    fill: "#4B164C"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 42,
    cy: 38,
    rx: 6,
    ry: 6,
    fill: "#4B164C"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 32,
    cy: 32,
    rx: 7,
    ry: 7,
    fill: "#4B164C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 8,
    width: 6,
    height: 20,
    rx: 3,
    fill: "#4B164C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.5,
    y: 2,
    width: 3,
    height: 10,
    rx: 1.5,
    fill: "#4B164C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.5cee244366fca3c56ccd7938922ab58a.svg";
export { ForwardRef as ReactComponent };